"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

var _Quantity = _interopRequireDefault(require("./Quantity.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quantity = function Quantity(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 1 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 999 : _ref$max,
      value = _ref.value,
      onChange = _ref.onChange;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = (0, _Quantity.default)();

  var handleAdd = function handleAdd() {
    if (value + 1 > max) return;
    onChange(parseInt(value + 1));
  };

  var handleChange = function handleChange(value) {
    if (value + 1 > max) {
      onChange(max);
      return;
    }

    onChange(value ? parseInt(value) : 1);
  };

  var handleRemove = function handleRemove() {
    if (value <= 0) return;
    onChange(parseInt(value - 1));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.quantity, "mco-shop-quantity")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, css.buttonRemove),
    variant: "outlined",
    onClick: handleRemove
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "".concat(REACT_APP_PATH, "/img/icons/shop/remove.svg"),
    size: 18
  })), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    classes: {
      root: css.textField
    },
    type: "number",
    value: value,
    variant: "outlined",
    onChange: function onChange(e) {
      return handleChange(parseInt(e.target.value));
    },
    InputProps: {
      className: css.textFieldInput,
      inputProps: {
        max: max,
        min: min
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, css.buttonAdd),
    variant: "outlined",
    onClick: handleAdd
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "".concat(REACT_APP_PATH, "/img/icons/shop/add.svg"),
    size: 18
  })));
};

var _default = Quantity;
exports.default = _default;